import React from 'react';
import { Box } from '@mui/material';

const MonitoringKM: React.FC = () => {
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <iframe
        src="https://mtr.zerdegroup.kz/mrk"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
        title="КМ"
      />
    </Box>
  );
};

export default MonitoringKM; 